import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { CommonFunctions } from 'src/app/Utilities/CommonFunctions';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HolidaysService {
  constructor(private http: HttpClient) {}

  private getHeaders() {
    const TOKEN = CommonFunctions.getToken();
    const user = CommonFunctions.getUser();
    return new HttpHeaders({
      Authorization: 'Bearer ' + TOKEN,
      'Content-Type': 'application/json',
      BusinessId: user?.businessId || ''
    });
  }

  listHolidays() {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/businessHolidays/admin/list';
    return this.http.get(url, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  addHoliday(holiday: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/businessHolidays/admin';
    return this.http.post(url, holiday, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  editHoliday(holiday: any, id: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/businessHolidays/admin/' + id;
    return this.http.put(url, holiday, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  removeHoliday(id: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/businessHolidays/admin/' + id;
    return this.http.delete(url, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  fetchYear(year: number) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/businessHolidays/admin/fetch?year=' + year;
    return this.http.get(url, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  bulkAddHolidays(year: number, holidays: any[]) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/businessHolidays/admin/bulkAdd?year=' + year;
    return this.http.post(url, holidays, { headers: this.getHeaders() }).pipe(timeout(60000));
  }
}
